import { render, staticRenderFns } from "./ui-drag.vue?vue&type=template&id=1eabea13"
import script from "./ui-drag.vue?vue&type=script&lang=ts"
export * from "./ui-drag.vue?vue&type=script&lang=ts"
import style0 from "./ui-drag.vue?vue&type=style&index=0&id=1eabea13&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports